<template>
  <div>
    <ProcessManagementChecklist
      v-if="contextLoaded && context.processInfo && context.processPath"
      :from-view="true"
      :process-info="context.processInfo"
    />
    <v-container v-else class="pa-6" style="min-height: 200px;">
      <v-row align="center" justify="center">
        <v-progress-circular color="primary" indeterminate />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProcessManagementChecklist
  from "@/components/management/processManagement/sections/ProcessManagementChecklist.vue";
import service_management from "@/services/service_management";

export default {
  name: "PKCChecklistDetailsTab",
  components: { ProcessManagementChecklist },
  props: {
    checklistId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      contextLoaded: false,
      context: {
        processInfo: null,
        processPKCInfo: null,
        processPath: null
      }
    };
  },
  async created() {
    try {
      const ctx = await service_management.getProcessManagementContextByChecklistId(this.checklistId);
      this.context = ctx;
    } catch (e) {
      // Silently fail; the loader will remain
      // Optionally, could show an error snackbar here
      console.error("Failed to load checklist context", e);
    } finally {
      this.contextLoaded = true;
    }
  }
};
</script>

<style scoped>
</style>
